<script>
	import { PRConnect } from "@projectroom/ui-lib";
	import axios from "axios";
	import { Dialog, Button } from "../../lib/ui";

	export let scenePromptContext;
	export let chat;
	export let isShow;

	let addSceneImageRef;
	let isEdit = false;
	$: isEdit =
		scenePromptContext?.title?.length > 0 &&
		scenePromptContext?.prompt?.length > 0;
	let refTitle, refPrompt;

	const onImageFileUpload = (e) => {
		chat.handleSceneImageFileUpload(e);
	};

	const handleClose = () => {
		chat.assignScenePromptContext(null, false);
	};

	// 등록/수정 버튼을 눌러야 값 업데이트
	const handleScenePromptContext = () => {
		scenePromptContext.changeTitle(refTitle.value);
		scenePromptContext.changePrompt(refPrompt.value);
		chat.saveScenePromptContext(scenePromptContext);
	};

	const inputCls =
		"tw-flex tw-h-10 tw-w-full tw-rounded-md tw-border tw-border-input tw-bg-background tw-px-3 tw-py-2 tw-text-sm tw-text-foreground placeholder:tw-text-muted-foreground focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring";
</script>

<Dialog open={isShow} title="상황 이미지 업로드" on:close={handleClose}>
	<div class="tw-space-y-4 tw-font-sans">
		<!-- 이미지 업로드 -->
		<div>
			<div class="tw-mb-1.5 tw-text-sm tw-font-medium tw-text-foreground">이미지</div>
			<div
				class="tw-group tw-relative tw-flex tw-min-h-[240px] tw-cursor-pointer tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-xl tw-border tw-border-border tw-bg-muted/40 tw-transition-colors hover:tw-border-primary"
				on:click={() => addSceneImageRef.click()}
				role="button"
				tabindex="0"
			>
				{#if scenePromptContext?.name}
					<img
						class="tw-max-h-[300px] tw-w-auto tw-object-contain"
						src={scenePromptContext.getImageUrl()}
						alt=""
					/>
					<div class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-black/45 tw-opacity-0 tw-transition-opacity group-hover:tw-opacity-100">
						<span class="tw-rounded-full tw-bg-white tw-px-4 tw-py-1.5 tw-text-sm tw-font-semibold tw-text-neutral-800">이미지 교체</span>
					</div>
				{:else}
					<div class="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-text-muted-foreground">
						<svg class="tw-h-8 tw-w-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 16V6m0 0l-3.5 3.5M12 6l3.5 3.5" /><path d="M4 15v2.5A2.5 2.5 0 006.5 20h11a2.5 2.5 0 002.5-2.5V15" /></svg>
						<span class="tw-text-sm tw-font-medium">클릭해서 이미지 업로드</span>
					</div>
				{/if}
				<input type="file" bind:this={addSceneImageRef} on:change={onImageFileUpload} hidden />
			</div>
		</div>

		<!-- 이미지 이름 -->
		<div>
			<div class="tw-mb-1.5 tw-text-sm tw-font-medium tw-text-foreground">이미지 이름</div>
			<input
				bind:this={refTitle}
				value={scenePromptContext.title}
				class={inputCls}
				placeholder="이미지에 대한 이름을 작성해주세요!"
				type="text"
			/>
		</div>

		<!-- 이미지 상황 -->
		<div>
			<div class="tw-mb-1.5 tw-text-sm tw-font-medium tw-text-foreground">이미지 상황</div>
			<input
				bind:this={refPrompt}
				value={scenePromptContext.prompt}
				class={inputCls}
				placeholder="(선택) 이 이미지를 띄울 상황을 적어주세요 — 블록을 쓰지 않을 때 LLM이 이 설명에 맞춰 이미지를 자동으로 띄웁니다"
				type="text"
			/>
		</div>
	</div>

	<svelte:fragment slot="footer">
		<Button on:click={handleScenePromptContext}>
			{scenePromptContext.isNewFlag ? "등록하기" : "수정하기"}
		</Button>
	</svelte:fragment>
</Dialog>
